<template>
  <div>
    <transition name="slide-fade" mode="out-in">

      <div v-if="state === 0 || state === 2">
      <form novalidate @submit.prevent="submit"><!-- edit -->
        <div class="row mt-3">
          <div class="col">
            <h3 v-if="showHeader">Контактная информация</h3>

            <div class="group">
              <div class="form-group">
                <label for="country">Страна:</label>
                <select
                  class="form-control form-control-sm"
                  id="country"
                  v-model="country"
                  style="background-color: azure;"
                  :class="{ 'is-invalid' : invalidValue(countryError) }"
                  @change="inputCountry"
                >
                  <option v-for="(country, index) in allCountry" :key="index" :value="index">{{ country }}</option>
                </select>
                <small class="form-text text-danger" v-if="invalidValue(countryError)">{{ errorTextCountry }}</small>
              </div>

              <Input
                type="text"
                caption="Область:"
                :small="true"
                bgColor="azure"
                @on-input="inputAddressState"
                :textError="errorTextAddressState"
                :isError="invalidValue(addressStateError)"
                :value="addressState"
              />
              <Input
                type="text"
                caption="Город:"
                :small="true"
                bgColor="azure"
                @on-input="inputCity"
                :textError="errorTextCity"
                :isError="invalidValue(cityError)"
                :value="city"
              />

              <div class="form-group">
                <label for="country">Прикрепление к региональному отделению АОПА-Россия:</label>
                <select
                  class="form-control form-control-sm"
                  id="aopaDistrict"
                  v-model="aopaDistrict"
                  style="background-color: azure;"
                  :class="{}"
                >
                  <option value="Без прикрепления к отделению">Без прикрепления к отделению</option>
                  <option value="Москва">Москва</option>
                  <option value="Московская область">Московская область</option>
                  <option value="Санкт-Петербург">Санкт-Петербург</option>
                  <option value="Ленинградская область">Ленинградская область</option>
                  <option value="Республика Башкортостан">Республика Башкортостан</option>
                  <option value="Краснодарский край">Краснодарский край</option>
                  <option value="Новгородская область">Новгородская область</option>
                  <option value="Новосибирская область">Новосибирская область</option>
                  <option value="Омская область">Омская область</option>
                  <option value="Пермский край">Пермский край</option>
                  <option value="Ростовская область">Ростовская область</option>
                  <option value="Самарская область">Самарская область</option>
                  <option value="Свердловская область">Свердловская область</option>
                  <option value="Ставропольский край">Ставропольский край</option>
                  <option value="Республика Татарстан">Республика Татарстан</option>
                  <option value="Тюменская область">Тюменская область</option>
                  <option value="Хабаровский край">Хабаровский край</option>
                  <option value="Республика Чувашия">Республика Чувашия</option>
                </select>
                <small class="form-text text-danger" v-if="invalidValue(countryError)">{{ errorTextCountry }}</small>
              </div>

              <Input
                type="number"
                caption="Индекс:"
                :small="true"
                bgColor="azure"
                @on-input="inputZip"
                :textError="errorTextZip"
                :isError="invalidValue(zipError)"
                :value="zip"
                :maxLength="maxLengthZip"
                :hideTextLength="true"
              />
              <Input
                type="text"
                caption="Улица:"
                :small="true"
                bgColor="azure"
                @on-input="inputAddressLine1"
                :textError="errorTextAddressLine1"
                :isError="invalidValue(addressLine1Error)"
                :value="addressLine1"
              />
              <Input
                type="text"
                caption="Дом, корпус, квартира:"
                :small="true"
                bgColor="azure"
                @on-input="inputAddressLine2"
                :textError="errorTextAddressLine2"
                :isError="invalidValue(addressLine2Error)"
                :value="addressLine2"
              />
              <hr>

              <Input
                type="text"
                caption="Основной email:"
                :small="true"
                bgColor="azure"
                :value="email"
                :disabled="true"
              />
              <div class="row" v-if="emails.length > 0/* && emails[1] !== emails*/">
                <div class="col"><p>Дополнительные email-ы</p></div>
              </div>
              <div class="row justify-content-between" v-for="(item, index) in emails" :key="index + item">
                <div class="col-10">
                  <Input
                    v-if="item !== email"
                    type="text"
                    :maxLength="255"
                    :hideTextLength="true"
                    :small="true"
                    bgColor="azure"
                    :value="item"
                    @on-input="(value) => { inputEmails(value, index) }"
                    :ref="'email' + index"
                  />
                </div>
                <div class="col-2 d-flex" v-if="item !== email">
                  <button
                    type="button"
                    class="btn btn-light rounded btn-sm align-self-start"
                    @click="delEmails(index)">удалить
                  </button>
                </div>
              </div>

              <div class="row">
                <div class="col">
                  <button type="button" class="btn btn-outline-secondary rounded btn-sm" @click="addEmails">Добавить email</button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </form>

      <!-- при вводе телефонов у каждого телефона своя форма, поэтому прерываем нашу основную форму {{{ -->
        <div class="row mt-3">
          <div class="col">
            <div class="group">
              <div class="row mt-2" v-if="phones.length">
                <div class="col"><p>Телефоны</p></div>
              </div>

              <PhoneInput  v-for="(item, index) in phones" :key="index + item + 1000"
                :small="true"
                bgColor="azure"
                @on-input="(value) => { inputPhones(value, index) }"
                :ref="'phone' + index"
                :value="item"
                @delete="delPhones(index)"
              />

              <div class="row">
                <div class="col">
                  <button type="button" class="btn btn-outline-secondary rounded btn-sm" @click="addPhones" :disabled="!canAddNewPhone" v-if="canAddNewPhone">Добавить ещё один телефон</button>
                </div>
              </div>
            </div>
          </div>
        </div>
      <!-- }}} -->

      <form novalidate @submit.prevent="submit"><!-- "продолжение" основной формы -->
        <div class="row mt-3"> <!-- button -->
          <div class="col" disabled v-if="showWaitDataUser">
            <button class="btn btn-primary" type="button">
              <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
              Загрузка...
            </button>
          </div>
          <template v-else>
            <div class="col">
              <button type="submit" class="btn btn-primary mr-1">
                Сохранить
              </button>
              <button type="button" class="btn btn-outline-info" @click="cancel()" v-if="state !== 2">
                Отменить
              </button>
            </div>
          </template>
        </div>
      </form>
      </div>

      <div class="row mt-3" v-else><!-- read -->
        <div class="col">
          <h3 v-if="showHeader">Контактная информация</h3>
          <button class="btn btn-secondary btn-sm float-right changeDataButton"  @click="state=0" v-if="smallEditButton">Изменить</button>
          <div class="group">
            <div class="row">
              <div class="col text-right text-muted">Страна:</div>
              <div class="col">{{ countryText }}</div>
            </div>
            <div class="row" v-if="addressState">
              <div class="col text-right text-muted">Область:</div>
              <div class="col">{{ addressState }}</div>
            </div>
            <div class="row">
              <div class="col text-right text-muted">Город:</div>
              <div class="col">{{ city }}</div>
            </div>
            <div class="row" v-if="aopaDistrictSetted">
              <div class="col text-right text-muted">Прикрепление к региональному отделению АОПА-Россия:</div>
              <div class="col">{{ aopaDistrict }}</div>
            </div>
            <div class="row">
              <div class="col text-right text-muted">Индекс:</div>
              <div class="col">{{ zip }}</div>
            </div>
            <div class="row">
              <div class="col text-right text-muted">Улица:</div>
              <div class="col">{{ addressLine1 }}</div>
            </div>
            <div class="row">
              <div class="col text-right text-muted">Дом, корпус, квартира:</div>
              <div class="col">{{ addressLine2 }}</div>
            </div>
            <hr>
            <div class="row">
              <div class="col text-right text-muted">email:</div>
              <div class="col">{{ email }}</div>
            </div>
            <template v-for="(elem, index) in emails"><!-- email -->
              <div class="row" :key="index" v-if="elem !== email">
                <div class="col"></div>
                <div class="col">{{ elem }}</div>
              </div>
            </template>
            <div class="row" v-for="(phone, index) in phones" :key="index + 'phone'">
              <div class="col text-right text-muted" v-if="index === 0">Телефоны:</div>
              <div class="col" v-else></div>
              <div class="col">{{ phone }}</div>
            </div>
          </div>
          <div class="row mt-3">
            <div class="col">
              <button type="button" class="btn btn-outline-info" @click="state=0" v-if="!smallEditButton">
                Редактирование
              </button>
            </div>
          </div>
        </div>
      </div>

    </transition>
  </div>
</template>

<script>
import Input from '@/components/Input.vue'
import PhoneInput from '@/components/PhoneInput.vue'
import { minLength, testEmail, isNumber } from '@/utils/Validate.js'
import { convertCountryCodeToCountry } from '@/utils/convertor.js'
import { mapGetters } from 'vuex'

export default {
  props: {
      showHeader: {
          type: Boolean,
          default: true
      },
      smallEditButton: {
          type: Boolean,
          default: false
      }
  },
  components: {
    Input,
    PhoneInput,
  },
  data() {
    return {
      emails: [],
      email: this.$store.getters.getUserData?.email || '',                    // основная почта
      phones: [],                                                             // телефоны
      country: this.$store.getters.getUserAddressInfo?.country || '',
      countryError: {
        minLength: false
      },
      addressState: this.$store.getters.getUserAddressInfo?.state || '',
      addressStateError: {
        minLength: false
      },
      city: this.$store.getters.getUserAddressInfo?.city || '',
      cityError: {
        minLength: false
      },
      zip: this.$store.getters.getUserAddressInfo?.zip || '',
      zipError: {
        minLength: false,
        wrongZip: false,
        maxLength: false
      },
      addressLine1: this.$store.getters.getUserAddressInfo?.address_line_1 ||'',
      addressLine1Error: {
        minLength: false
      },
      addressLine2: this.$store.getters.getUserAddressInfo?.address_line_2 ||'',
      addressLine2Error: {
        minLength: false
      },
      aopaDistrict: this.$store.getters.getUserData?.memberInfo?.aopaDistrict || 'Без прикрепления к отделению',
      aopaDistrictSetted: !!(this.$store.getters.getUserData?.memberInfo?.aopaDistrict || '').length,
      showWaitDataUser: false,
      state: 1,

      address: '',// del
    }
  },
  mounted() {
    this.firstLoad()
  },
  computed: {
    ...mapGetters(['getUserData']),
    errorTextCity: function() {
      let error = "";
      if (this.cityError.minLength) error = "Поле не должно быть пустым!"
      return error;
    },
    errorTextAddressState: function() {
      let error = "";
      if (this.addressStateError.minLength) error = "Поле не должно быть пустым!"
      return error;
    },
    errorTextCountry: function() {
      let error = "";
      if (this.countryError.minLength) error = "Поле не должно быть пустым!"
      return error;
    },
    errorTextZip: function() {
      let error = "";
      if (this.zipError.minLength) error = "Введено недостаточно цифр"
      if (this.zipError.maxLength) error = "Введено слишком много символов"
      if (this.zipError.wrongZip) error = "Нужно использовать только числовые значения"
      return error;
    },
    errorTextAddressLine1: function() {
      let error = "";
      if (this.addressLine1Error.minLength) error = "Поле не должно быть пустым!"
      return error;
    },
    errorTextAddressLine2: function() {
      let error = "";
      if (this.addressLine2Error.minLength) error = "Поле не должно быть пустым!"
      return error;
    },
    allCountry: function() {
      return convertCountryCodeToCountry()
    },
    maxLengthZip: function() {
      if (this.country === 'RU') return 6
      return 0
    },
    countryText: function() {
      return convertCountryCodeToCountry(this.country)
    },
    canAddNewPhone() {
        return !this.phones.length || (this.phones[ this.phones.length - 1 ] !== '');
    }
  },
  methods: {
    invalidValue(obj) {           // Проверяем значение на ошибки
      for (let key in obj) {
        if (obj[key]) return true
      }
      return false
    },
    inputEmails(value, index) {
      this.emails[index] = value
      this.$refs['email' + index][0].classError = false
    },
    inputPhones(value, index) {
      this.$set(this.phones, index, value);
    },
    inputAddressState(value) {
      this.addressStateError.minLength = false; // не требуем заполнения поля «Область»
      this.addressState = value
    },
    inputCountry() {
      this.countryError.minLength = minLength(this.country)
    },
    inputCity(value) {
      this.cityError.minLength = minLength(value)
      this.city = value
    },
    inputZip(value) {
      this.zipError.minLength = minLength(value, this.maxLengthZip)
      this.zipError.maxLength = false
      this.zipError.wrongZip = isNumber(value)
      this.zip = value
    },
    inputAddressLine1(value) {
      this.addressLine1Error.minLength = minLength(value)
      this.addressLine1 = value
    },
    inputAddressLine2(value) {
      this.addressLine2Error.minLength = minLength(value)
      this.addressLine2 = value
    },
    addPhones() {
      if (this.phones[this.phones.length - 1] === '') return
      this.phones.push('')
    },
    addEmails() {
      if (this.emails[this.emails.length - 1] === '') return
      this.emails.push('')
    },
    delPhones(index) {
      if (this.phones.length === 1) {
        this.$store.commit('setDataToast', { state: 0, text: 'Должен быть указан хотя бы один телефон' })
        return
      }
      if (!this.phones[index] || confirm('Удалить телефон «' + this.phones[index] + '»?')) {
          this.phones.splice(index, 1)
        }
    },
    delEmails(index) {
        if (!this.emails[index] || confirm('Удалить емейл «' + this.emails[index] + '»?')) {
            this.emails.splice(index, 1)
        }
    },
    firstLoad() {
      if (!this.getUserData.memberInfo) {
        this.phones.push('')
        this.state = 2
        return
      }

      // contact
      if (this.getUserData.memberInfo.emails?.length > 0) { // email
        for (let item of this.getUserData.memberInfo.emails) {
          this.emails.push(item.value)
        }
      }

      if (this.getUserData.memberInfo.phones.length === 0) { // tel
        this.phones.push('')
        this.state = 2
      } else {
        for (let item of this.getUserData.memberInfo.phones) {
          this.phones.push(item.value)
        }
      }

      if (this.country === '' ||
          this.city === '' ||
          this.zip === '' ||
          this.addressLine1 === ''
      ) {
            // state
            this.state = 2
      }
    },
    submit() {
      this.countryError.minLength = minLength(this.country)
      this.addressStateError.minLength = false; // не требуем заполнения поля «Область»
      this.cityError.minLength = minLength(this.city)
      this.zipError.minLength = minLength(this.zip, this.maxLengthZip)
      this.zipError.wrongZip = isNumber(this.zip)
      if (this.maxLengthZip > 0) this.zipError.maxLength = this.zip.length > this.maxLengthZip
      this.addressLine1Error.minLength = minLength(this.addressLine1)
      this.addressLine2Error.minLength = minLength(this.addressLine2)

      let emailsAccept = true
      let phoneAccept = true

      for (let i=0; i<this.emails.length; i++) {
        if (this.emails[i] !== this.email) {
          const error = !testEmail(this.emails[i])
          if (error) emailsAccept = false
          this.$refs['email' + i][0].classError = error
        }
      }

      for (let i=0; i<this.phones.length; i++) {
        const error = minLength(this.phones[i])
        if (error) phoneAccept = false
        this.$refs['phone' + i][0].classError = error
        this.$refs['phone' + i][0].tryToSave();
      }

      // проверка
      if (emailsAccept &&
          phoneAccept &&
          !this.invalidValue(this.addressStateError) &&
          !this.invalidValue(this.countryError) &&
          !this.invalidValue(this.cityError) &&
          !this.invalidValue(this.zipError) &&
          !this.invalidValue(this.addressLine1Error) &&
          !this.invalidValue(this.addressLine2Error)) {

        // submit
        const data = new FormData()

        for (let i=0; i < this.emails.length; i++) {
          data.append(`emails[${i}]`, this.emails[i])
        }
        for (let i=0; i < this.phones.length; i++) {
          data.append(`phones[${i}]`, this.phones[i])
        }

        const addressInfo = JSON.stringify({
          country: this.country,
          state: this.addressState,
          city: this.city,
          zip: this.zip,
          address_line_1: this.addressLine1,
          address_line_2: this.addressLine2,
        })
        data.append('addressInfo', addressInfo)

        data.append('aopaDistrict', this.aopaDistrict);

        this.showWaitDataUser = true
        this.$store.dispatch('saveInfo', data)
        .then(() => {
          this.state = 1
          this.$emit("accept");
          this.$store.dispatch('loginWithCookie')
          .then(() =>{
            this.cancel()
          })
        })
        .finally(() => {
          this.showWaitDataUser = false
        })
      } else {
        this.$store.commit('setDataToast', { state: 0, text: 'Заполните все поля без ошибок' })
      }
    },
    cancel() {
      this.state = 1;
      this.emails = [];
      this.phones = [];

      this.country = this.$store.getters.getUserAddressInfo?.country || ''
      this.addressState = this.$store.getters.getUserAddressInfo?.state || ''
      this.city = this.$store.getters.getUserAddressInfo?.city || ''
      this.zip = this.$store.getters.getUserAddressInfo?.zip || ''
      this.addressLine1 = this.$store.getters.getUserAddressInfo?.address_line_1 || ''
      this.addressLine2 = this.$store.getters.getUserAddressInfo?.address_line_2 || ''

      this.firstLoad()
    }
  }
}
</script>

<style scoped>
  .group {
    border-left: 5px groove rgba(0, 174, 255, 0.959);
    padding-left: 10px;
  }
  textarea.disabled {
    border: none;
    cursor: default;
    background-color: white;
    color: black;
  }
</style>
